export default __webpack_public_path__ + "img/Inter-Light_8b60946.woff2";